// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3tZ6C","wallet-div":"Header_wallet-div__3_oGz","wallet-address":"Header_wallet-address__1W9Ae","end-dropdowns":"Header_end-dropdowns__2_51W"};